<template>
    <div>
        <div class="designeroption" id="frame_style" data-designer-component-id="side_panels">
            <h3>Configure Your Frame</h3>

            <div class="activatepanels" v-show="!isFiredoor">
                <div class="txt">
                    <p>Select your frame configuration by clicking on the plus on the sidepanel and top box areas.</p>
                    <p>Once you select a sidepanel further options will be available.</p>
                </div>
                <div class="options">
                    <div class="topbox">
                        <input type="checkbox" value="top" v-model="target.checkedPanels" :disabled="(typeRange == 146 || typeRange == 147) && (sideIsChecked('left') || sideIsChecked('right'))"/>
                    </div>
                    <div class="sidepanels">
                        <input type="checkbox" value="left" v-model="target.checkedPanels" :disabled="(typeRange == 146 || typeRange == 147) && sideIsChecked('top')"/>
                        <img :src="'/images/activatepanelsimg.jpg'" alt="" class="doorimg"/>
                        <input type="checkbox" value="right" v-model="target.checkedPanels" :disabled="(typeRange == 146 || typeRange == 147) && sideIsChecked('top')"/>
                    </div>
                </div>
            </div>

            <div class="activatepanels" v-show="isFiredoor">
                <div class="txt">
                    <p>Select your frame configuration by clicking on the plus on the sidepanel and top box areas.</p>
                    <p>Once you select a sidepanel further options will be available.</p>
                </div>

                <div class="options" :class="['options', sideIsChecked('top') ? 'disabled-right disabled-left' : '', sideIsChecked('left') ? 'disabled-top disabled-right' : '', sideIsChecked('right') ? 'disabled-top disabled-left' : '']">
                    <div class="topbox">
                        <input type="checkbox" value="top" v-model="target.checkedPanels" :disabled="sideIsChecked('left') || sideIsChecked('right')"/>
                    </div>
                    <div class="sidepanels">
                        <input type="checkbox" value="left" v-model="target.checkedPanels" :disabled="sideIsChecked('top') || sideIsChecked('right')"/>
                        <img :src="'/images/activatepanelsimg.jpg'" alt="" class="doorimg"/>
                        <input type="checkbox" value="right" v-model="target.checkedPanels" :disabled="sideIsChecked('top') || sideIsChecked('left')"/>
                    </div>
                </div>
            </div>

        </div>

        <truedor-designer-question-frame-style :fabricator="fabricator" :is-firedoor="isFiredoor" :frame-material="frameMaterial" :type-range="typeRange"  :title="title" v-model:target="target.frame_id" :checked-panels="target.checkedPanels">

        </truedor-designer-question-frame-style>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionSelectFrameStyle from "../DesignerQuestionSelectFrameStyle.vue";

    export default {
        mixins: [
            DesignerQuestionSelectFrameStyle
        ],
        props: {
            isFiredoor: {
                required: true
            },
            frameMaterial: {
                required: true
            },
        }
    }
</script>
